import OpportunityReporter from "./components/OpportunityReporter";

export default OpportunityReporter